import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

// Floating "back to top" button — appears after scrolling down, on desktop & mobile.
export default function ScrollTopButton() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  // The premium PWA shell has its own scroll area + bottom nav; the floating
  // button would overlap its cards, so skip it there.
  const hidden = /\/panchang(a|am)-premium\/app/.test(pathname);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    const root = document.documentElement;
    const prev = root.style.scrollBehavior;
    root.style.scrollBehavior = "smooth";
    window.scrollTo({ top: 0 });
    setTimeout(() => { root.style.scrollBehavior = prev; }, 600);
  };

  if (hidden) return null;

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Scroll to top"
      data-testid="scroll-top-button"
      className={`fixed bottom-5 right-5 z-[60] flex h-11 w-11 items-center justify-center rounded-full border border-[var(--gold)]/50 bg-[var(--saffron)] text-white shadow-lg transition-all duration-300 hover:bg-[var(--saffron-dark)] sm:bottom-7 sm:right-7 sm:h-12 sm:w-12 ${show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
